import React, { useState } from 'react';
import { BarChart, PieChart, LineChart, Calendar, Download, Filter, ChevronDown, RefreshCw, FileText, Clock, Users, FolderOpen, ArrowUpRight, ArrowDownRight, Search, Share2, Printer, X } from 'lucide-react';
import { DepartmentSelector } from './DepartmentSelector';
export const ReportingDashboard = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [dateRange, setDateRange] = useState('last30Days');
  const [activeReport, setActiveReport] = useState(null);
  return <div className="p-6" data-id="element-768">
      <div className="flex justify-between items-center mb-6" data-id="element-769">
        <div className="flex items-center space-x-4" data-id="element-770">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-771">
            Reports & Analytics
          </h1>
          <DepartmentSelector activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-772" />
        </div>
        <div className="flex items-center space-x-3" data-id="element-773">
          <select className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-774">
            <option value="last7Days" data-id="element-775">Last 7 Days</option>
            <option value="last30Days" data-id="element-776">Last 30 Days</option>
            <option value="last90Days" data-id="element-777">Last 90 Days</option>
            <option value="lastYear" data-id="element-778">Last Year</option>
            <option value="custom" data-id="element-779">Custom Range</option>
          </select>
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-780">
            <RefreshCw className="h-4 w-4" data-id="element-781" />
            <span data-id="element-782">Refresh</span>
          </button>
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-783">
            <Download className="h-4 w-4" data-id="element-784" />
            <span data-id="element-785">Export</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-6 mb-6" data-id="element-786">
        <MetricCard title="Total Documents" value="1,248" change="+12%" isPositive={true} icon={<FileText className="h-5 w-5 text-blue-600" data-id="element-788" />} color="blue" data-id="element-787" />
        <MetricCard title="Active Workflows" value="42" change="+8%" isPositive={true} icon={<Clock className="h-5 w-5 text-purple-600" data-id="element-790" />} color="purple" data-id="element-789" />
        <MetricCard title="Active Users" value="87" change="+5%" isPositive={true} icon={<Users className="h-5 w-5 text-green-600" data-id="element-792" />} color="green" data-id="element-791" />
        <MetricCard title="Storage Used" value="2.4 GB" change="-3%" isPositive={false} icon={<FolderOpen className="h-5 w-5 text-yellow-600" data-id="element-794" />} color="yellow" data-id="element-793" />
      </div>

      <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-795">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-796">
          <div className="flex justify-between items-center mb-6" data-id="element-797">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-798">
              Document Activity
            </h2>
            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-799">
              View Details
            </button>
          </div>
          <div className="h-64 flex items-center justify-center" data-id="element-800">
            {/* Placeholder for chart */}
            <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-801">
              <BarChart className="h-16 w-16 text-gray-300" data-id="element-802" />
              <span className="ml-3 text-gray-400" data-id="element-803">
                Document Activity Chart
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-804">
          <div className="flex justify-between items-center mb-6" data-id="element-805">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-806">
              Workflow Completion
            </h2>
            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-807">
              View Details
            </button>
          </div>
          <div className="h-64 flex items-center justify-center" data-id="element-808">
            {/* Placeholder for chart */}
            <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-809">
              <LineChart className="h-16 w-16 text-gray-300" data-id="element-810" />
              <span className="ml-3 text-gray-400" data-id="element-811">
                Workflow Completion Chart
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6 mb-6" data-id="element-812">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-813">
          <div className="flex justify-between items-center mb-6" data-id="element-814">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-815">
              Document Types
            </h2>
            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-816">
              View Details
            </button>
          </div>
          <div className="h-64 flex items-center justify-center" data-id="element-817">
            {/* Placeholder for chart */}
            <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-818">
              <PieChart className="h-16 w-16 text-gray-300" data-id="element-819" />
              <span className="ml-3 text-gray-400" data-id="element-820">Document Types Chart</span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-821">
          <div className="flex justify-between items-center mb-6" data-id="element-822">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-823">User Activity</h2>
            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-824">
              View Details
            </button>
          </div>
          <div className="h-64 flex items-center justify-center" data-id="element-825">
            {/* Placeholder for chart */}
            <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-826">
              <BarChart className="h-16 w-16 text-gray-300" data-id="element-827" />
              <span className="ml-3 text-gray-400" data-id="element-828">User Activity Chart</span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-829">
          <div className="flex justify-between items-center mb-6" data-id="element-830">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-831">
              Department Distribution
            </h2>
            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-832">
              View Details
            </button>
          </div>
          <div className="h-64 flex items-center justify-center" data-id="element-833">
            {/* Placeholder for chart */}
            <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-834">
              <PieChart className="h-16 w-16 text-gray-300" data-id="element-835" />
              <span className="ml-3 text-gray-400" data-id="element-836">
                Department Distribution Chart
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-837">
        <div className="flex justify-between items-center mb-6" data-id="element-838">
          <h2 className="text-lg font-medium text-gray-800" data-id="element-839">
            Available Reports
          </h2>
          <div className="flex items-center space-x-3" data-id="element-840">
            <div className="relative w-64" data-id="element-841">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" data-id="element-842" />
              <input type="text" placeholder="Search reports..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" data-id="element-843" />
            </div>
            <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-844">
              <Filter className="h-4 w-4" data-id="element-845" />
              <span data-id="element-846">Filters</span>
              <ChevronDown className="h-4 w-4" data-id="element-847" />
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-848">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-849">
            <thead className="bg-gray-50" data-id="element-850">
              <tr data-id="element-851">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-852">
                  Report Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-853">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-854">
                  Last Generated
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-855">
                  Frequency
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-856">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-857">
              {reports.map(report => <tr key={report.id} className="hover:bg-gray-50" data-id="element-858">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-859">
                    <div className="flex items-center" data-id="element-860">
                      <div className="h-8 w-8 bg-blue-100 rounded-md flex items-center justify-center text-blue-600" data-id="element-861">
                        <FileText className="h-4 w-4" data-id="element-862" />
                      </div>
                      <div className="ml-3" data-id="element-863">
                        <div className="text-sm font-medium text-gray-900 hover:text-blue-600 cursor-pointer" onClick={() => setActiveReport(report)} data-id="element-864">
                          {report.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-865">
                    {report.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-866">
                    {report.lastGenerated}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-867">
                    {report.frequency}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-868">
                    <button className="text-blue-600 hover:text-blue-900 mr-3" onClick={() => setActiveReport(report)} data-id="element-869">
                      View
                    </button>
                    <button className="text-gray-600 hover:text-gray-900 mr-3" data-id="element-870">
                      <Download className="h-4 w-4" data-id="element-871" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {activeReport && <ReportViewerModal report={activeReport} onClose={() => setActiveReport(null)} data-id="element-872" />}
    </div>;
};
const MetricCard = ({
  title,
  value,
  change,
  isPositive,
  icon,
  color
}) => {
  const getColorClass = color => {
    switch (color) {
      case 'blue':
        return 'bg-blue-50';
      case 'purple':
        return 'bg-purple-50';
      case 'green':
        return 'bg-green-50';
      case 'yellow':
        return 'bg-yellow-50';
      default:
        return 'bg-gray-50';
    }
  };
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-873">
      <div className="flex justify-between items-start" data-id="element-874">
        <div data-id="element-875">
          <p className="text-sm text-gray-500" data-id="element-876">{title}</p>
          <h3 className="text-2xl font-bold text-gray-800 mt-1" data-id="element-877">{value}</h3>
          <div className="flex items-center mt-2" data-id="element-878">
            {isPositive ? <ArrowUpRight className="h-4 w-4 text-green-500 mr-1" data-id="element-879" /> : <ArrowDownRight className="h-4 w-4 text-red-500 mr-1" data-id="element-880" />}
            <span className={`text-xs ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-881">
              {change} from last period
            </span>
          </div>
        </div>
        <div className={`h-12 w-12 rounded-lg ${getColorClass(color)} flex items-center justify-center`} data-id="element-882">
          {icon}
        </div>
      </div>
    </div>;
};
const ReportViewerModal = ({
  report,
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-883">
      <div className="bg-white w-full max-w-5xl h-[90vh] rounded-lg flex flex-col overflow-hidden" data-id="element-884">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-885">
          <div className="flex items-center" data-id="element-886">
            <div className="h-10 w-10 bg-blue-100 rounded-md flex items-center justify-center text-blue-600" data-id="element-887">
              <FileText className="h-6 w-6" data-id="element-888" />
            </div>
            <div className="ml-3" data-id="element-889">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-890">
                {report.name}
              </h2>
              <p className="text-sm text-gray-500" data-id="element-891">
                {report.category} • Last generated: {report.lastGenerated}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-892">
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-893">
              <Download className="h-5 w-5" data-id="element-894" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-895">
              <Printer className="h-5 w-5" data-id="element-896" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-897">
              <Share2 className="h-5 w-5" data-id="element-898" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" onClick={onClose} data-id="element-899">
              <X className="h-5 w-5" data-id="element-900" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-6" data-id="element-901">
          <div className="space-y-6" data-id="element-902">
            <div className="flex justify-between items-center" data-id="element-903">
              <h3 className="text-xl font-medium text-gray-800" data-id="element-904">
                Report Summary
              </h3>
              <div className="flex items-center space-x-3" data-id="element-905">
                <select className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-906">
                  <option value="last30Days" data-id="element-907">Last 30 Days</option>
                  <option value="lastQuarter" data-id="element-908">Last Quarter</option>
                  <option value="lastYear" data-id="element-909">Last Year</option>
                  <option value="custom" data-id="element-910">Custom Range</option>
                </select>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-6 mb-6" data-id="element-911">
              <p className="text-gray-700" data-id="element-912">{report.description}</p>
            </div>
            <div className="grid grid-cols-3 gap-6 mb-6" data-id="element-913">
              {report.metrics.map((metric, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-914">
                  <p className="text-sm text-gray-500" data-id="element-915">{metric.name}</p>
                  <h4 className="text-xl font-bold text-gray-800 mt-1" data-id="element-916">
                    {metric.value}
                  </h4>
                </div>)}
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6" data-id="element-917">
              <h4 className="text-lg font-medium text-gray-800 mb-4" data-id="element-918">
                Report Visualization
              </h4>
              <div className="h-80 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-919">
                {/* Placeholder for chart */}
                {report.type === 'bar' ? <BarChart className="h-16 w-16 text-gray-300" data-id="element-920" /> : report.type === 'pie' ? <PieChart className="h-16 w-16 text-gray-300" data-id="element-921" /> : <LineChart className="h-16 w-16 text-gray-300" data-id="element-922" />}
                <span className="ml-3 text-gray-400" data-id="element-923">{report.name} Chart</span>
              </div>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-924">
              <div className="p-4 border-b border-gray-200" data-id="element-925">
                <h4 className="text-lg font-medium text-gray-800" data-id="element-926">
                  Detailed Data
                </h4>
              </div>
              <div className="overflow-x-auto" data-id="element-927">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-928">
                  <thead className="bg-gray-50" data-id="element-929">
                    <tr data-id="element-930">
                      {report.tableHeaders.map((header, index) => <th key={index} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-931">
                          {header}
                        </th>)}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-932">
                    {report.tableData.map((row, rowIndex) => <tr key={rowIndex} data-id="element-933">
                        {row.map((cell, cellIndex) => <td key={cellIndex} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-934">
                            {cell}
                          </td>)}
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const reports = [{
  id: 1,
  name: 'Document Activity Report',
  category: 'Document Management',
  lastGenerated: 'Today, 9:30 AM',
  frequency: 'Daily',
  type: 'bar',
  description: 'This report provides an overview of document activity across all departments, including uploads, downloads, edits, and views. The data is broken down by document type and department.',
  metrics: [{
    name: 'Total Documents',
    value: '1,248'
  }, {
    name: 'New Documents',
    value: '87'
  }, {
    name: 'Document Views',
    value: '2,456'
  }],
  tableHeaders: ['Department', 'Uploads', 'Downloads', 'Edits', 'Views'],
  tableData: [['General Manager Office', '45', '120', '32', '350'], ['Finance Department', '78', '215', '67', '580'], ['HR Department', '56', '178', '43', '420'], ['IT Department', '92', '264', '81', '630'], ['Legal Department', '34', '98', '29', '290'], ['Audit Department', '28', '76', '18', '186']]
}, {
  id: 2,
  name: 'Workflow Performance Report',
  category: 'Workflow Management',
  lastGenerated: 'Yesterday',
  frequency: 'Weekly',
  type: 'line',
  description: 'This report analyzes workflow performance metrics including completion rates, average completion time, and bottlenecks. It helps identify process inefficiencies and opportunities for improvement.',
  metrics: [{
    name: 'Active Workflows',
    value: '42'
  }, {
    name: 'Avg. Completion Time',
    value: '4.3 days'
  }, {
    name: 'Completion Rate',
    value: '86%'
  }],
  tableHeaders: ['Workflow Type', 'Count', 'Avg. Time', 'Completion Rate', 'Bottleneck Step'],
  tableData: [['Document Approval', '18', '3.2 days', '92%', 'Final Review'], ['Budget Request', '7', '5.6 days', '78%', 'Finance Approval'], ['Employee Onboarding', '5', '2.8 days', '95%', 'IT Setup'], ['Contract Review', '12', '6.1 days', '74%', 'Legal Review']]
}, {
  id: 3,
  name: 'User Activity Report',
  category: 'User Management',
  lastGenerated: 'Aug 15, 2023',
  frequency: 'Weekly',
  type: 'bar',
  description: 'This report tracks user activity within the system, including login frequency, document interactions, and workflow participation. It helps monitor system usage and identify training needs.',
  metrics: [{
    name: 'Active Users',
    value: '87'
  }, {
    name: 'Avg. Session Time',
    value: '42 min'
  }, {
    name: 'Total Actions',
    value: '5,872'
  }],
  tableHeaders: ['Department', 'Active Users', 'Avg. Sessions', 'Document Actions', 'Workflow Actions'],
  tableData: [['General Manager Office', '8', '12', '245', '86'], ['Finance Department', '15', '18', '678', '124'], ['HR Department', '12', '15', '432', '98'], ['IT Department', '20', '22', '756', '135'], ['Legal Department', '9', '14', '387', '76'], ['Audit Department', '7', '10', '289', '53']]
}, {
  id: 4,
  name: 'Storage Utilization Report',
  category: 'System Administration',
  lastGenerated: 'Aug 10, 2023',
  frequency: 'Monthly',
  type: 'pie',
  description: 'This report provides an overview of storage utilization across the system, broken down by department and document type. It helps manage storage resources and plan for future capacity needs.',
  metrics: [{
    name: 'Total Storage Used',
    value: '2.4 GB'
  }, {
    name: 'Available Space',
    value: '7.6 GB'
  }, {
    name: 'Largest Department',
    value: 'Finance (0.8 GB)'
  }],
  tableHeaders: ['Department', 'Storage Used', 'Document Count', 'Avg. File Size', 'Largest File'],
  tableData: [['General Manager Office', '0.4 GB', '215', '1.9 MB', '25.6 MB'], ['Finance Department', '0.8 GB', '342', '2.4 MB', '48.2 MB'], ['HR Department', '0.3 GB', '187', '1.7 MB', '18.9 MB'], ['IT Department', '0.5 GB', '276', '1.8 MB', '32.4 MB'], ['Legal Department', '0.3 GB', '156', '2.0 MB', '27.8 MB'], ['Audit Department', '0.1 GB', '72', '1.5 MB', '15.3 MB']]
}, {
  id: 5,
  name: 'Department Performance Report',
  category: 'Executive',
  lastGenerated: 'Aug 1, 2023',
  frequency: 'Monthly',
  type: 'bar',
  description: 'This report compares performance metrics across departments, including document processing times, workflow efficiency, and user productivity. It provides executive insights for organizational management.',
  metrics: [{
    name: 'Most Efficient Dept',
    value: 'IT Department'
  }, {
    name: 'Fastest Workflow',
    value: 'Document Approval'
  }, {
    name: 'Most Active Dept',
    value: 'Finance'
  }],
  tableHeaders: ['Department', 'Doc Processing Time', 'Workflow Efficiency', 'User Productivity', 'Overall Score'],
  tableData: [['General Manager Office', '1.8 days', '85%', '92%', 'A-'], ['Finance Department', '2.3 days', '78%', '94%', 'B+'], ['HR Department', '1.5 days', '82%', '88%', 'B+'], ['IT Department', '1.2 days', '91%', '95%', 'A+'], ['Legal Department', '2.7 days', '76%', '85%', 'B'], ['Audit Department', '2.1 days', '79%', '87%', 'B']]
}];